import { Component, Injector, Input, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { DateTime } from 'luxon';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { forkJoin, interval, of, Subscription } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { AllDashboardServiceProxy, CalculationTimeAndAttendanceDto, CheckInCheckOutDto, CombineUserInfoDto, GetAllCurrentProjectDto, LocationSettingInfoDto, ProjectMemberImagesDto, ProjectServiceProxy, SetUserStatusDto, TimeAndAttendanceServiceProxy, TimeAndAttendanceUserInfoDto, TrackWorkingDetailCreateOrEditDto, UserDetailsDto, UserStatusEnum } from '../../../../../shared/service-proxies/service-proxies';
import { SignalRService } from '../../../../shared/services/signalr.service';
import { DashboardUserTimeDataService } from '../dashboard-user-time-data.service';
import { AppRoutes } from '@app/shared/routes/app-routes';
import { ProjectService } from '../../../projects-new/Services/project.service';
import { AppConsts } from '@shared/AppConsts';
import { resolveProfileImageUrl } from '@shared/utils/profile-image.util';
@Component({
    standalone: false,
    selector: 'app-user-infosection',
    templateUrl: './user-infosection.component.html',
    styleUrls: ['./user-infosection.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserInfosectionComponent extends AppComponentBase implements OnInit, OnDestroy {
    userDetails = new TimeAndAttendanceUserInfoDto();
    mySubscription: Subscription;
    userData = new TimeAndAttendanceUserInfoDto();
    @Input()
    userId: number;
    @Input()
    tenantId: number;
    @ViewChild('projectsTabs')
    projectsTabs: TabsetComponent;
    status = 1;
    progressBar: any = 60;
    progressBarForWork;
    projectCount;
    startDate: any = "May 21,2022";
    endDate: any = "Dec 20,2022";
    hours: any = 3;
    trackWorkingDetail = new TrackWorkingDetailCreateOrEditDto();
    locationsData: LocationSettingInfoDto[] = [];
    locationSelectedId: number;
    workStartTempTime: Date;
    workEndTempTime: Date;
    locationEmailReceiverDto: ProjectMemberImagesDto[] = [];
    selectedLocation: LocationSettingInfoDto;
    progressBarForTime;
    isLate: boolean = false;
    isearly;
    isOnTime;
    workingType: any;
    projectId;
    projectType;
    activeIndex1: number = 0;
    resolution: string = 'medium';
    getCurrentTime: string;
    activeIndex2: number = 0;
    activeIndex = 0;
    items;
    statusOptions = {
        1: "dot-working",
        2: "dot-idle",
        3: "dot-meeting",
        4: "dot-checkin",
        5: "dot-checkout",
        6: "dot-privatetime",
    };
    currentProjectDto: GetAllCurrentProjectDto[];
    progressBarUserData = new CalculationTimeAndAttendanceDto();
    isProductivityBarTriggered: boolean;
    constructor(private _AllDashboardServiceProxy: AllDashboardServiceProxy, private _signalRService: SignalRService, private _router: Router, private _projectServiceProxy: ProjectServiceProxy, private _timeandAttendanceServiceProxy: TimeAndAttendanceServiceProxy, private _dashboardUserTimeDataService: DashboardUserTimeDataService, private projectService: ProjectService, injector: Injector) { super(injector); }
    userStatusStrArray: string[] = ['Working', 'Idle', 'Meeting', 'Lunch', 'CheckIn', 'CheckOut', 'OnMobile', 'PrivateTime'];
    userCurrentStatus: string = 'CheckIn';
    passStatus: number;
    currTime: Date;
    checkInTime: DateTime;
    currentsTime: any;
    finalTime: DateTime;
    isLoaded = false;
    isEmpty = true;
    diffmilisec: number;
    DisplaDiffStr: string;
    isUserCheckedIn: boolean = false;
    getDate: Date;
    timerSub: Subscription;
    private readonly passDataToUserInfoSectionHandler = (data) => this.getUserTimeDetailsAfterApi(data, true);
    private readonly signalRUserStatusHandler = (data) => this.createcallBackFunctionsforSignalR(data);
    private readonly profilePictureChangedHandler = (imagePath?: string) => this.onProfilePictureChanged(imagePath);
    CheckinOffset: any;
    checkInValue: number;
    h: number;
    m: number;
    sec: number;
    currentUserStatus: number;
    time: number = 0;
    interval: any;
    currentTime: number = 0;
    play: boolean = false;
    activeTime: string = '00:00';
    isProjectDataLoaded: boolean = false;
    ngOnInit(): void {
        abp.event.on('passDataToUserInfoSection', this.passDataToUserInfoSectionHandler);
        abp.event.on('profilePictureChanged', this.profilePictureChangedHandler);
        this._timeandAttendanceServiceProxy.combineUserDetails(abp?.session?.userId, abp?.session?.tenantId, undefined).subscribe(res => {
            this.getUserDetails(res);
            this.workingType = res.workingType;
            this.isEmpty = false;
            this.isLoaded = true;
            this.userCheckInCheckOut(res);
            this.markForCheck();
        });
        this.getCurrentProjectDetails();
        this.play = true;
        this.getDate = new Date();
        this.getUserTimedetails();
        if (!this.tenantId && !this.userId) {
            this.tenantId = abp.session.tenantId;
            this.userId = abp.session.userId;
        }
        this.initSignalR();
    }
    // SignalR event for initialize user status
    initSignalR() {
        abp.event.on("SignalRAgentUserStatus", this.signalRUserStatusHandler);
    }
    //** data parmeter used to avoid duplicate event in the applications for signalR
    data: any;
    public async createcallBackFunctionsforSignalR(objValues) {
        //** When Page is refreshed at first time signal r event get called multiple times for the same event so timer run by twicely adding value
        if (this.data === undefined) {
            this.data = objValues;
        }
        else if (this.data.userStatus !== objValues.userStatus) {
            this.data = objValues;
        }
        else {
            return;
        }
        this.timerSub?.unsubscribe();
        await this.userCheckInCheckOut();
    }
    async userCheckInCheckOut(r?: CombineUserInfoDto) {
        if (!r) {
            let d = new Date();
            await this._AllDashboardServiceProxy.getCurrentStateCheckInCheckOut(abp.session.userId, abp.session.tenantId, d.getTimezoneOffset(), DateTime.fromJSDate(this.setZeroTimeForLocalDate(d))).subscribe(r => {
                if (r.userCurrentStatus != UserStatusEnum.Offline) {
                    this.CheckinOffset = r.offset; //this.getOffsetFromStartingTime(r.time);
                    this.UserstateChechInCheckOuttimer(this.CheckinOffset);
                    this.passStatus = 6;
                    this.userCurrentStatus = 'CheckOut';
                    this.isUserCheckedIn = false;
                }
                else {
                    if (r.userCurrentStatus === UserStatusEnum.Offline) {
                        this.userCurrentStatus = 'CheckIn';
                        this.isUserCheckedIn = true;
                        if (r.lastCheckInTime != undefined) {
                            this.currentTime = this.getOffsetForCheckedOut(r.lastCheckInTime, r.time);
                        }
                        this.CheckinOffset = this.currentTime;
                    }
                    this.timerSub?.unsubscribe();
                }
                this.markForCheck();
            });
        }
        else {
            if (r.userCurrentStatus != UserStatusEnum.Offline) {
                this.CheckinOffset = r.offset; //this.getOffsetFromStartingTime(r.time);
                this.UserstateChechInCheckOuttimer(this.CheckinOffset);
                this.passStatus = 6;
                this.userCurrentStatus = 'CheckOut';
                this.isUserCheckedIn = false;
            }
            else {
                if (r.userCurrentStatus === UserStatusEnum.Offline) {
                    this.userCurrentStatus = 'CheckIn';
                    this.isUserCheckedIn = true;
                    if (r.lastCheckInTime != undefined) {
                        this.currentTime = this.getOffsetForCheckedOut(r.lastCheckInTime, r.time);
                    }
                    this.CheckinOffset = this.currentTime;
                }
                this.timerSub?.unsubscribe();
            }
        }
    }
    setZeroTimeForLocalDate(date: Date): Date {
        date.setHours(0, 0, 0, 0);
        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    }
    toApiCalendarDate(date: Date = new Date()): DateTime {
        const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const utcMidnight = this.setZeroTimeForLocalDate(localDate);
        return DateTime.utc(utcMidnight.getUTCFullYear(), utcMidnight.getUTCMonth() + 1, utcMidnight.getUTCDate());
    }
    UserstateChechInCheckOuttimer(offset?: number) {
        this.currentTime = offset || 0;
        this.timerSub?.unsubscribe();
        this.timerSub = interval(1000).subscribe((seconds) => {
            this.currentTime++;
            this.markForCheck();
        });
    }
    getUserDetails(result: CombineUserInfoDto) {
        this.userDetails = result.userInfoDetail ?? new TimeAndAttendanceUserInfoDto();
        this.userDetails.profileImage = this.resolveDashboardProfileImage(this.userDetails.profileImage);
        if (!this.userDetails.userName?.trim()) {
            const sessionUser = this.appSession.user;
            this.userDetails.userName = `${sessionUser?.name ?? ''} ${sessionUser?.surname ?? ''}`.trim();
        }
        this.currentUserStatus = result.userCurrentStatus;
        this.isEmpty = false;
        this.isLoaded = true;
        let hours = new Date().getHours();
        let minutes = new Date().getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? 0 + minutes : minutes;
        this.getCurrentTime = hours + ':' + minutes + ' ' + ampm;
    }
    getUserStatus(id: UserStatusEnum) {
        return id != null ? UserStatusEnum[id] : "Unknown";
    }
    getCurrentProjectDetails() {
        let date = new Date();
        date.setHours(0, 0, 0, 0);
        this._AllDashboardServiceProxy.getAllCurrentProjects().subscribe(result => {
            this.enrichCurrentProjectManagers(result || []);
        });
    }

    // Dashboard current-projects payload often omits managers; fill them from project details
    // so every tenant sees the assigned Project Manager(s) on the card.
    private enrichCurrentProjectManagers(projects: GetAllCurrentProjectDto[]) {
        if (!projects.length) {
            this.currentProjectDto = projects;
            this.projectCount = 0;
            this.isProjectDataLoaded = true;
            this.markForCheck();
            return;
        }

        forkJoin(
            projects.map(project =>
                this._projectServiceProxy.getProjectById(project.id).pipe(
                    map(details => {
                        const managers = this.projectService.resolveAssignedProjectManagers(details);
                        project.assignedProjectManager = managers.map(manager =>
                            UserDetailsDto.fromJS({
                                userId: manager.id,
                                userImage: manager.profileImage,
                                userName: manager.fullName || `${manager.name || ''} ${manager.surname || ''}`.trim()
                            })
                        );
                        return project;
                    }),
                    catchError(() => of(project))
                )
            )
        ).subscribe(enrichedProjects => {
            this.currentProjectDto = enrichedProjects;
            this.projectCount = enrichedProjects.length;
            this.isProjectDataLoaded = true;
            this.markForCheck();
        });
    }
    redirectToViewPage(id: number, projectTypeId: number) {
        this._router.navigate([AppRoutes.projectsDetails], { state: { ProjectId: id, option: projectTypeId }, queryParams: { ProjectId: id, option: projectTypeId } });
    }
    getProjectProgress(startD: Date, endD: Date) {
        if (!startD || !endD)
            return 0;
        let progressBar = 0;
        var startDate = new Date(startD.toString());
        var endDate = new Date(endD.toString());
        const PresentDay = new Date();
        if ((startDate > endDate) || (startDate > PresentDay)) {
            progressBar = 0;
        }
        else if (PresentDay > endDate) {
            progressBar = 100;
        }
        else {
            progressBar = (PresentDay.getTime() - startDate.getTime()) * 100 / (endDate.getTime() - startDate.getTime());
        }
        progressBar = Math.floor(progressBar);
        return progressBar;
    }
    getUserTimedetails() {
        if (this.isProductivityBarTriggered)
            return;
        let date = new Date();
        date.setHours(0, 0, 0, 0);
        this._timeandAttendanceServiceProxy.getUserCalculationBaseOnActivity(abp?.session?.userId, abp?.session?.tenantId, this.toApiCalendarDate(date), date.getTimezoneOffset(), this.toApiCalendarDate(date), this.toApiCalendarDate(date), undefined).subscribe(result => {
            this.getUserTimeDetailsAfterApi(result);
            this.markForCheck();
        });
    }
    getUserTimeDetailsAfterApi(result, isTriggered = false) {
        this.isProductivityBarTriggered = isTriggered;
        this.progressBarUserData = result;
        this.activeTime = this.getHoursAndMinutes(result?.trackedTime);
        this._dashboardUserTimeDataService.setUserTimeDetails(result);
        this.isLoaded = true;
        this.isEmpty = false;
        if (this.progressBarUserData.workStartDate !== undefined)
            this.workStartTempTime = this.progressBarUserData.workStartDate.toJSDate();
        if (this.progressBarUserData.workEndDate !== undefined)
            this.workEndTempTime = this.progressBarUserData.workEndDate.toJSDate();
        let getFinalTime = (Math.round((this.currentTime / 3600)) * 10);
        this.progressBarForTime = getFinalTime;
        if (this.progressBarUserData.arrivalTime > this.progressBarUserData.workStartDate) {
            this.isLate = true;
        }
        if (this.progressBarUserData.leftDateTime != null) {
            let getWorkEndTime = (this.workEndTempTime.getHours() * 60 + this.workEndTempTime.getMinutes());
            let leftTime = (this.progressBarUserData.leftDateTime.hour * 60) + this.progressBarUserData.leftDateTime.minute;
            if (Math.round((getWorkEndTime)) > leftTime) {
                this.isearly = true;
            }
            else if (Math.round((getWorkEndTime)) < leftTime) {
                this.isOnTime = true;
            }
        }
    }
    getHoursAndMinutes(timestamp: string) {
        if (!timestamp)
            return '00:00';
        let hours = Math.floor(parseInt(timestamp.split(":")[0]));
        let min = parseInt(timestamp.split(":")[1]);
        return `${hours < 10 ? "0" + hours : hours}:${min < 10 ? "0" + min : min}`;
    }
    getUserList() {
        this._projectServiceProxy.getProjectMemberImages().subscribe(result => {
            this.locationEmailReceiverDto = result;
            this.markForCheck();
        });
    }
    ngOnDestroy(): void {
        abp.event.off('passDataToUserInfoSection', this.passDataToUserInfoSectionHandler);
        abp.event.off("SignalRAgentUserStatus", this.signalRUserStatusHandler);
        abp.event.off('profilePictureChanged', this.profilePictureChangedHandler);
        this.timerSub?.unsubscribe();
    }

    private onProfilePictureChanged(imagePath?: string): void {
        const resolvedImage = resolveProfileImageUrl(
            imagePath,
            AppConsts.loggedInUserImage,
            localStorage.getItem('imagePath'),
            this.userDetails.profileImage
        );
        this.userDetails.profileImage = resolvedImage || undefined;
        this.markForCheck();
    }

    private resolveDashboardProfileImage(profileImage: string | undefined): string | undefined {
        const resolvedImage = resolveProfileImageUrl(
            profileImage,
            AppConsts.loggedInUserImage,
            localStorage.getItem('imagePath')
        );
        return resolvedImage || undefined;
    }
    getOffsetForCheckedOut(lastCheckIn: DateTime, LastCheckOut: DateTime) {
        return Math.floor((new Date(LastCheckOut?.toUTC().toString()).getTime() - new Date(lastCheckIn?.toUTC().toString()).getTime()) / 1000);
    }
    getOffsetFromStartingTime(startingTime: DateTime) {
        return Math.floor((new Date(DateTime.now().toUTC().toString()).getTime() - new Date(startingTime?.toUTC().toString()).getTime()) / 1000);
    }
    //** Start Or Stop Timer
    startAndStopTimer() {
        this.passStatus = this.userCurrentStatus === 'CheckIn' ? UserStatusEnum.Online : UserStatusEnum.Offline;
        this.userCurrentStatus = this.userCurrentStatus === 'CheckIn' ? 'CheckOut' : 'CheckIn';
        //** If Offline then stop timer
        if (this.passStatus === UserStatusEnum.Offline) {
            this.timerSub.unsubscribe();
        }
        //** If online then start timer from old stoped time
        if (this.passStatus === UserStatusEnum.Online) {
            this.UserstateChechInCheckOuttimer(this.currentTime);
        }
        //** Send Responce to the backend
        let checkInCheckOutDto = new CheckInCheckOutDto();
        checkInCheckOutDto.userId = 0;
        checkInCheckOutDto.status = this.passStatus;
        this._AllDashboardServiceProxy.checkInCheckOut(checkInCheckOutDto).subscribe(() => {
            if (this.passStatus === UserStatusEnum.Offline) {
                let inputpar = new SetUserStatusDto();
                inputpar.userStatus = UserStatusEnum.Offline;
                inputpar.userId = abp.session.userId;
                inputpar.tenantId = abp.session.tenantId;
                this._signalRService.sendMessage('SignalRChangeStatusOnAgentAppForCheckinCheckout', inputpar);
            }
            if (this.passStatus === UserStatusEnum.Online) {
                let inputpar = new SetUserStatusDto();
                inputpar.userStatus = UserStatusEnum.Online;
                inputpar.userId = abp.session.userId;
                inputpar.tenantId = abp.session.tenantId;
                this._signalRService.sendMessage('SignalRChangeStatusOnAgentAppForCheckinCheckout', inputpar);
            }
            this.markForCheck();
        });
    }
    changestate() {
        this.passStatus = this.userCurrentStatus === 'CheckIn' ? UserStatusEnum.Online : UserStatusEnum.Offline;
        if (this.passStatus == UserStatusEnum.Offline) {
            this.timerSub.unsubscribe();
        }
        else if (this.userCurrentStatus === 'CheckIn') {
            this.UserstateChechInCheckOuttimer(this.CheckinOffset);
        }
        this.userCurrentStatus = this.userCurrentStatus === 'CheckIn' ? 'CheckOut' : 'CheckIn';
        let checkInCheckOutDto = new CheckInCheckOutDto();
        checkInCheckOutDto.userId = 0;
        checkInCheckOutDto.status = this.passStatus;
        this._AllDashboardServiceProxy.checkInCheckOut(checkInCheckOutDto).subscribe(() => {
            this.userCheckInCheckOut();
            this.markForCheck();
        });
        let d = new Date();
        this._AllDashboardServiceProxy.getCurrentStateCheckInCheckOut(abp.session.userId, abp.session.tenantId, d.getTimezoneOffset(), DateTime.fromJSDate(this.setZeroTimeForLocalDate(d))).subscribe(r => {
            this.markForCheck();
        });
    }
    // get local js date from a UTC datetime object
    getLocalJsDate(date: DateTime): Date {
        if (!date)
            return;
        let jsDate = new Date(`${date.year}-${date.month < 10 ? '0' + date.month : date.month}-${date.day < 10 ? '0' + date.day : date.day}T${date.hour < 10 ? '0' + date.hour : date.hour}:${date.minute < 10 ? '0' + date.minute : date.minute}:00`);
        return new Date(jsDate.getTime() - jsDate.getTimezoneOffset() * 60 * 1000);
    }
    userFullname(name: string) {
        if (!name)
            return '-';
        let fullname = name.split(" ");
        name = fullname.length > 1 && fullname[1] != '' ? this.getTitleCase(fullname[0]) + " " + this.getTitleCase(fullname[1]) : this.getTitleCase(fullname[0]);
        return name;
    }
    // function which return titlecase string;
    getTitleCase(s: string) {
        let char = s[0].toUpperCase();
        return char + s.slice(1)?.toLowerCase();
    }
}
